import { useNavigate } from "react-router-dom";
import { Button, Modal, Typography } from "@/components/atoms";

interface CannotDisconnectModalProps {
  open: boolean;
  onClose: () => void;
  operatorName: string;
}

export const CannotDisconnectModal = ({ open, onClose, operatorName }: CannotDisconnectModalProps) => {
  const navigate = useNavigate();

  const handleGoToBookings = () => {
    onClose();
    navigate("/bookings");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Can't Disconnect Operator"
      variant="web-small"
      renderButtons={() => (
        <>
          <Button variant="tertiary" size="md" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" size="md" onClick={handleGoToBookings}>
            Go to Bookings
          </Button>
        </>
      )}
    >
      <div className="flex flex-col gap-3">
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          {`You can't disconnect from ${operatorName} because you currently have upcoming jobs offloaded or reassigned to them.`}
        </Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          Please recall or reassign those jobs before disconnecting this operator.
        </Typography>
      </div>
    </Modal>
  );
};
